export let EVENT_USER_AUTHENTICATED:string = "user:authenticated";

export let EVENT_USER_DELETED:string = "user:deleted";

export let EVENT_USER_REDIRECTED:string = "user:redirected";

export let EVENT_USER_UNAUTHORIZED:string = "user:unauthorized";

export let EVENT_ACCOUNT_DELETED:string = "account:deleted";

export let EVENT_GROUP_ADDED:string = "group:added";

export let EVENT_GROUP_CHANGED:string = "group:changed";

export let EVENT_GROUP_DELETED:string = "group:deleted";

export let EVENT_CHECKIN_DETAILS:string = "checkin:details";

export let EVENT_CHECKIN_CREATED:string = "checkin:created";

export let EVENT_CHECKIN_UPDATED:string = "checkin:updated";

export let EVENT_CREDITS_CHANGED:string = "credits:changed";

export let EVENT_SUBSCRIPTION_CHANGED:string = "subscription:changed";

export let EVENT_CHECKINS_WAITING_CHANGED:string = "checkinswaiting:changed";

export let EVENT_NOTIFICATIONS_CHANGED:string = "notifications:changed";

export let EVENT_FIREBASE_TOKEN:string = "firebase:token";



// WEBPACK FOOTER //
// ./src/constants/events.ts